import * as React from 'react';

function CartIconV2(props) {
	return (
		<svg
			aria-label={`cart icon`}
			width={'33'}
			height={'25'}
			viewBox={'0 0 33 25'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>cart icon</title>
			<path d={'M10.8969 18.6144H27.7367L31.5 5.6456H26.0936'} stroke={'white'} strokeWidth={'1.8'} strokeMiterlimit={'10'} />
			<path d={'M7.07068 5.91666H13.3124'} stroke={'white'} strokeWidth={'1.8'} />
			<path d={'M12.3047 24.75L5.77991 0.75'} stroke={'white'} strokeWidth={'1.8'} strokeMiterlimit={'10'} />
			<path d={'M0.5 1.56366H6.8488'} stroke={'white'} strokeWidth={'1.8'} strokeMiterlimit={'10'} />
			<path d={'M11.2211 23.9232H25.7191'} stroke={'white'} strokeWidth={'1.8'} strokeMiterlimit={'10'} />
			<path d={'M15.5171 9.77148H24.6517'} stroke={'white'} strokeWidth={'1.5'} />
			<path d={'M20.084 5.20422L20.084 14.3389'} stroke={'white'} strokeWidth={'1.5'} />
		</svg>
	);
}

export default CartIconV2;
